
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("kCmuH", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $77d9414fa9e67b02$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Russian
var $77d9414fa9e67b02$export$2e2bcd8739ae039 = {
    'fabric.editor.headingLink.ascSortingLabel': "\u043F\u043E \u0432\u043E\u0437\u0440\u0430\u0441\u0442\u0430\u043D\u0438\u044E",
    'fabric.editor.headingLink.copied': "\u0421\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043D\u043E!",
    'fabric.editor.headingLink.copyAnchorLink': "\u041A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0441\u0441\u044B\u043B\u043A\u0443 \u0432 \u0437\u0430\u0433\u043E\u043B\u043E\u0432\u043E\u043A",
    'fabric.editor.headingLink.copyAriaLabel': "\u0421\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C",
    'fabric.editor.headingLink.descSortingLabel': "\u043F\u043E \u0443\u0431\u044B\u0432\u0430\u043D\u0438\u044E",
    'fabric.editor.headingLink.failedToCopy': "\u041E\u0448\u0438\u0431\u043A\u0430 \u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F",
    'fabric.editor.headingLink.noneSortingLabel': "\u041D\u0435\u0442",
    'fabric.editor.inlineComment.marker.end': "\u043A\u043E\u043D\u0435\u0446 \u0432\u0441\u0442\u0440\u043E\u0435\u043D\u043D\u043E\u0433\u043E \u043A\u043E\u043C\u043C\u0435\u043D\u0442\u0430\u0440\u0438\u044F",
    'fabric.editor.inlineComment.marker.start': "\u043D\u0430\u0447\u0430\u043B\u043E \u0432\u0441\u0442\u0440\u043E\u0435\u043D\u043D\u043E\u0433\u043E \u043A\u043E\u043C\u043C\u0435\u043D\u0442\u0430\u0440\u0438\u044F"
};

});


//# sourceMappingURL=ru.89f80ee0.js.map
